














































import { Vue, Component, Emit, Prop } from "vue-property-decorator";

@Component
export default class SciptBuilderLanding extends Vue {
    public get buttons() {
        return [
            {
                src: "newbook.svg",
                action: this.newPage,
                title: this.$t("script.new"),
            },
            {
                src: "logoload2.svg",
                action: this.startLoad,
                title: this.$t("script.load"),
            },

            {
                src: "powerpoint.svg",
                action: this.startImport,
                title: this.$t("script.bar.import"),
            },
        ];
    }
    public startImport() {
        (this.$refs.fileSelect as HTMLInputElement).click();
    }
    public handleImport(event: InputEvent) {
        const fileList = (event.target as HTMLInputElement).files;
        if (fileList && fileList.length > 0) {
            const file = fileList.item(0);
            if (file) {
                this.import({ file });
            }
        }
    }
    @Emit() public newPage() {
        return;
    }
    @Emit() public startLoad() {
        return;
    }
    @Emit() public import(event: { file: File }) {
        return event;
    }
    @Prop() importing: boolean = false;
}
